import { render, staticRenderFns } from "./VolunteerApplyDetail.vue?vue&type=template&id=0c15be20&scoped=true"
import script from "./VolunteerApplyDetail.vue?vue&type=script&lang=js"
export * from "./VolunteerApplyDetail.vue?vue&type=script&lang=js"
import style0 from "./VolunteerApplyDetail.vue?vue&type=style&index=0&id=0c15be20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c15be20",
  null
  
)

export default component.exports